import { type ScrollElementOptions, scrollElementInternal } from './scrollIntoView'

const scrollable = (eventTarget: EventTarget, scrollElement: HTMLElement, containerElement: HTMLElement) => ({
	subscribe(name: string, handler: () => void) {
		eventTarget.addEventListener(name, handler)

		return () => eventTarget.removeEventListener(name, handler)
	},
	scrollTo(x: number, y: number) {
		scrollElement.scrollTo(x, y)
	},
	scrollIntoView(options: ScrollElementOptions) {
		scrollElementInternal(containerElement, scrollElement, 'scrollIntoView', options)
	},
	scrollToTop(options: ScrollElementOptions) {
		scrollElementInternal(containerElement, scrollElement, 'scrollToTop', options)
	},
	disable() {
		const previous = scrollElement.style.overflow
		scrollElement.style.overflow = 'hidden'
		return () => {
			scrollElement.style.overflow = previous
		}
	},
	get scrollTop() {
		return scrollElement.scrollTop
	},
	set scrollTop(value) {
		scrollElement.scrollTop = value
	},
	get height() {
		return scrollElement.clientHeight
	},
	get offsetTop() {
		const { top: scrollTop } = scrollElement.getBoundingClientRect()
		const { top: containerTop } = containerElement.getBoundingClientRect()

		return containerTop - scrollTop
	},
	scrollElement,
	containerElement,
})

export type ScrollParent = ReturnType<typeof scrollable>

export const getScrollParent = (node: HTMLElement, containerElement = node): ScrollParent | undefined => {
	const { overflowX, overflowY } = getComputedStyle(node)
	if (overflowX === 'auto' || overflowX === 'scroll' || overflowY === 'auto' || overflowY === 'scroll') {
		return scrollable(node, node, containerElement)
	}
	if (node.parentElement) {
		return getScrollParent(node.parentElement, containerElement)
	}
	if (document.documentElement === node) {
		return scrollable(window, document.documentElement, containerElement)
	}
	return undefined
}
